import { GetSessionByIdQuery } from '@/Types/gql/graphql';
import { makeVar, ReactiveVar } from '@apollo/client'; // Adjust the import path as needed

// Define the type for a single session
export type SessionData = NonNullable<GetSessionByIdQuery['getSessionById']>;

// Create a reactive variable to hold the session data
export const sessionVar: ReactiveVar<SessionData | null> = makeVar<SessionData | null>(null);
export const preSessionVar: ReactiveVar<boolean> = makeVar<boolean>(false);
export const miniScreenUserIdVar: ReactiveVar<string | number | null> = makeVar<
  string | number | null
>(null);

export const activeMediaDeviceVar = makeVar({
  mic: '',
  speaker: '',
  camera: '',
});
